import { render } from "./ticket-list.vue?vue&type=template&id=41644464"
import script from "./ticket-list.vue?vue&type=script&lang=js"
export * from "./ticket-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__